import type { TableOfContentsItemUpdatePanelFragment } from "../../client/generated";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { TableOfContentsItemFormField } from "./TableOfContentsItemFormField";
import {
  useDeleteTableOfContentsItemFromPanelMutation,
  useUpdateTableOfContentsItemFromPanelMutation,
} from "../../client/generated";

type Props = {
  fragment: TableOfContentsItemUpdatePanelFragment;
};

export function TableOfContentsItemUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [updateAttribute] = useUpdateTableOfContentsItemFromPanelMutation();
  const [deleteAttribute] = useDeleteTableOfContentsItemFromPanelMutation();
  const [linkedRegionId, setLinkedRegionId] = useState(
    fragment.linkedRegion?.id,
  );

  const onSave = async () => {
    await updateAttribute({
      variables: {
        attributeId: fragment.id,
        linkedRegionId: linkedRegionId ?? "",
      },
    });
  };

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("TableOfContentsItemUpdatePanel.title")}
      unsaved={linkedRegionId !== fragment.linkedRegion?.id}
      onSubmit={onSave}
      onDelete={onDelete}
    >
      <TableOfContentsItemFormField
        fragment={fragment.region}
        value={linkedRegionId}
        onValueChange={setLinkedRegionId}
      />
    </AttributePanel>
  );
}
